import {
  Badge,
  BadgeColor,
} from '@delmonicos/shared-design-system-react/src/components/badge/badge';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tooltip } from '@delmonicos/shared-design-system-react/src/components/tooltip/tooltip';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoRfidBadgeOrderListRfidBadgeVisualNumbersCellProps
  extends CellContext<
    BackOfficeRfidBadgeOrderModel,
    BackOfficeRfidBadgeOrderModel['rfidBadgeVisualNumbers']
  > {}

export const EmspBoRfidBadgeOrderListRfidBadgeVisualNumbersCell = (
  props: EmspBoRfidBadgeOrderListRfidBadgeVisualNumbersCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ///////////////////////////////////////////////////////////////////

  const value = getValue();

  if (!value || value.length === 0) {
    return <span>—</span>;
  }

  const [first, ...rest] = value;

  return (
    <Stack direction="row" alignItems="center" gap={GapEnum.XS}>
      <span>{first}</span>
      {rest.length > 0 && (
        <Tooltip content={rest.join(', ')}>
          <Badge color={BadgeColor.Secondary}>
            <Text
              bold={false}
              fontSize={TextFontSize.Small}>{`+${rest.length}`}</Text>
          </Badge>
        </Tooltip>
      )}
    </Stack>
  );
};
